import React from 'react';
import { useNavigate } from 'react-router-dom';

const reportCategories = [
  {
    title: 'Overview Reports',
    reports: [
      { name: 'Sales Overview', path: '/company-report' },
      { name: 'Invoice Summary', path: '/invoice-summary' },
      { name: 'Top Selling Products', path: '/top-selling-products' },
    ]
  },
  {
    title: 'Sales Reports',
    reports: [
      { name: 'Sales By Product', path: '/sales-by-product' },
      { name: 'Sales By Day', path: '/sales-by-day' },
      { name: 'Sales By Payment Method', path: '/sales-by-payment' },
      { name: 'Sales By Cashier', path: '/sales-by-cashier' },
      { name: 'Cancelled Orders', path: '/cancelled-orders' },
      { name: 'End of Day Statements', path: '/end-of-day-statements' },
    ]
  },
  {
    title: 'Common Reports',
    reports: [
      { name: 'Profit & Lost', path: '/profit-lost' },
      { name: 'Tax Summary', path: '/tax-summary' },
    ]
  }
];

export default function SalesReportMenu() {
  const navigate = useNavigate();
  const handleReportClick = (_reportName, reportPath) => {
    navigate(reportPath);
  };

  return (
    <div className="p-6 text-white">
      <div>
        <h1 className="text-3xl font-bold">All Reports</h1>
        <p className="text-sm text-gray-400">Reports that you can generate to analyze your sales data.</p>
      </div><br/>

      {reportCategories.map((category, idx) => (
        <div key={idx} className="mb-8">
          <h2 className="text-lg font-semibold mb-3">{category.title}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {category.reports.map((report, i) => (
              <div
                key={i}
                onClick={() => handleReportClick(report.name, report.path)}
                className="bg-[#1f1f1f] hover:bg-purple-700 hover:text-white transition p-4 rounded-lg cursor-pointer border border-gray-700"
              >
                <div className="flex items-center gap-2">
                  <svg className="w-5 h-5 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v8m-6 0a2 2 0 002 2h2a2 2 0 002-2" />
                  </svg>
                  <span>{report.name}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
